import React from "react";
import Contact from "./Contact";
import Image from "next/image";
import Link from "next/link";

import Offices from "./Offices";
import BannerBottom from "./BannerBottom";
import { AICBadgeInline } from "./AICBadge";

export default function Foot() {
  return (
    <footer>
      <div className="sm:rounded-b-3xl  shadow-2xl sm:m-10">
        <Contact />
        <BannerBottom />
        <div className="w-full   font-cinzel bg-white sm:rounded-b-3xl  dark:bg-blue-600   mx-auto  md:pb-8 justify-center place-items-center">
          <div className="grid sm:flex sm:px-10 w-full   items-center justify-items-center center   ">
            <Offices />

            <div className="w-full  sm:w-1/2  grid p-10 sm:pt-0  justify-center align-middle    ">
              <div className="flex w-full justify-evenly ">
                <a
                  href="tel:+1-416-450-2336"
                  alt="Official Phone number for Alpha Appraisals"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="fill-blue-500 h-6 sm:h-6 dark:fill-white   hover:fill-black   w-auto"
                  >
                    <path d="M16 0v3h-8c-1.104 0-2 .896-2 2v17c0 1.104.896 2 2 2h8c1.104 0 2-.896 2-2v-22h-2zm-6 21h-2v-1h2v1zm0-2h-2v-1h2v1zm0-2h-2v-1h2v1zm3 4h-2v-1h2v1zm0-2h-2v-1h2v1zm0-2h-2v-1h2v1zm3 4h-2v-1h2v1zm0-2h-2v-1h2v1zm0-2h-2v-1h2v1zm0-3h-8v-8h8v8z" />
                  </svg>
                </a>
                <a
                  href="mailto:info@alphaappraisals.ca"
                  alt="Email for Alpha Appraisals"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="mx-auto text h-6 sm:h-6 w-auto dark:fill-white  fill-blue-500 hover:fill-black"
                  >
                    <path d="M12 12.713l-11.985-9.713h23.97l-11.985 9.713zm0 2.574l-12-9.725v15.438h24v-15.438l-12 9.725z" />
                  </svg>{" "}
                </a>

                <a
                  href="https://www.linkedin.com/company/alpha-appraisals-inc"
                  alt="Official LinkedIn Page for Alpha Appraisals Inc"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="mx-auto text h-6 sm:h-6 w-auto fill-blue-500 dark:fill-white hover:fill-black"
                  >
                    <path d="M0 0v24h24v-24h-24zm8 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.397-2.586 7-2.777 7 2.476v6.759z" />
                  </svg>
                </a>
              </div>
              <div className="flex justify-center pt-5">
                <AICBadgeInline />
              </div>
              <hr className="h-px my-5 bg-gray-200 border-0 dark:bg-white" />{" "}
              <ul className=" grid  items-center   text-sm font-medium  sm:mb-0 text-center ">
                <li>
                  <Link href="/FAQ" className="hover:underline  ">
                    Terms & Conditions
                  </Link>
                </li>
              </ul>
              <div className=" flex pt-2">
                <Image
                  className="h-6 w-auto     "
                  height={100}
                  width={100}
                  src="/logo.png"
                  alt="Alpha Appraisals Logo"
                />
                <span className=" text-sm grid sm:text-center justify-center center align-middle ">
                  <span className="dark:text-white text-xs ">
                    ©2026 Alpha Appraisals Inc
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
